import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

import { getRequirementDefinitionTableCellProps } from "../../../../../RequirementDefinitions/utils";
import {
  CellsConfig,
  ContextItem,
  RequirementTableCallback
} from "../../../../types";
import { getRequirementEngagementsTableCellProps } from "../../../../utils";
import { getRegistrationRequirementName } from "../helpers/getRegistrationRequirementName";
import { getRegistrationRequirementPayeeStatusCell } from "../helpers/getRegistrationRequirementPayeeStatusCell";

export const usePayeeRegistrationConfig = (
  _callback: RequirementTableCallback
): CellsConfig<PayeeRequirement, ContextItem, undefined> => {
  return {
    isActionRequired: () => false,

    requirementName: getRegistrationRequirementName,

    toolbarActions: (requirement, context, additionalData) => {
      return [];
    },

    nameCell: requirement => ({
      text: getRegistrationRequirementName(requirement)
    }),

    typeCell: requirement =>
      getRequirementDefinitionTableCellProps({
        type: requirement.type!
      }),

    statusCell: getRegistrationRequirementPayeeStatusCell,

    engagementsCell: getRequirementEngagementsTableCellProps
  };
};
